export class ApprovalStatus {

    constructor() {
        this.isApproved = false;
    }

    isApproved: boolean;
}